import { useEffect } from 'react'
import { Box, Typography, Link } from '@mui/material'

function TermsAndConditions ({ onValidationChange }) {
  // Informational only - nothing on this section blocks the user from continuing
  useEffect(() => {
    onValidationChange(true)
  }, [onValidationChange])

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h6'>Code of Rights/Privacy Statement</Typography>
      <Typography variant='body1' sx={{ mt: 2 }}>
        Please see the{' '}
        <Link href='https://birthcare.co.nz/your-rights/' target='_blank' rel='noopener noreferrer'>
          Code of Rights
        </Link>{' '}
        and{' '}
        <Link href='https://birthcare.co.nz/privacy-policy/' target='_blank' rel='noopener noreferrer'>
          Privacy Statement
        </Link>.
      </Typography>
    </Box>
  )
}

export default TermsAndConditions
